import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const TransactionsPerMonthProcessPayloadSchema = z.object({
    transactions: z.number().optional(),
});

export class TransactionsPerMonthProcessPayload extends FromSchema(TransactionsPerMonthProcessPayloadSchema) {
    transactions?: number;
}
